import React, { ReactElement } from "react";

import { AnimatedSpinner } from "studio-design-system";

import * as styles from "./LoadingPage.css";

export const LoadingPage = (): ReactElement => {
  return (
    <div className={styles.container}>
      <AnimatedSpinner />
    </div>
  );
};
